"use strict";

var _interopRequireDefault = require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _grade = require("@/api/grade");
var _pos = require("@/api/pos");
var _vuex = require("vuex");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _default = {
  data: function data() {
    return {
      list: [],
      url: '',
      visible: false,
      loading: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user'])),
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      (0, _grade.getList)().then(function (res) {
        _this.list = res.data;
      });
    },
    handleCode: function handleCode(id) {
      var _this2 = this;
      this.visible = true;
      this.loading = true;
      (0, _pos.upgradeCode)({
        grade_id: id
      }).then(function (res) {
        _this2.url = res.data.code;
        clearInterval(_this2.timer);
        _this2.timer = null;
        _this2.timer = setInterval(function () {
          _this2.handleVerify(res.data.order_no);
        }, 4000);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    handleVerify: function handleVerify(order_no) {
      var that = this;
      (0, _pos.checkPay)({
        order_no: order_no
      }).then(function (res) {
        if (res.code === 0 && JSON.stringify(res.data) !== '{}') {
          clearInterval(that.timer);
          that.timer = null;
          that.$emit('next');
        }
      });
    },
    handleClose: function () {
      var _handleClose = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$confirm('若已支付请等待页面跳转，请勿关闭二维码', '提示', {
                confirmButtonText: '还未支付',
                cancelButtonText: '取消'
              });
            case 2:
              res = _context.sent;
              if (res === 'confirm') {
                clearInterval(this.timer);
                this.timer = null;
                this.visible = false;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleClose() {
        return _handleClose.apply(this, arguments);
      }
      return handleClose;
    }()
  }
};
exports.default = _default;